<div *transloco="let t" class="py-4">
	<ara-editor [(model)]="coverText" [placeholder]="exampleText" [disabled]="disabled()"></ara-editor>
</div>
